export default __webpack_public_path__ + "static/media/righteous-latin.4c3896ac.woff2";